import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Stepped from "./stepped/Stepped";

function App() {
  return (
    <div className="App bg-f7f7f8">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Stepped />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
